import ptBR from './sources/pt-br.json' with {type: 'json'};

export const translations = {
	'pt-br': ptBR,
};
